import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

import { SheetFieldInstanceFragmentGql } from './SheetFieldInstanceFragmentGql';

export const ViewDetailsByPathQueryGql: DocumentNode = gql`
query ViewDetailsByPathQuery($viewPath: String!) {
  views (filter: { path: $viewPath }, permissionMode: FILTER_RESULTS) {
    __typename
    id
    name
    updatedAt
    path
    workbook {
      owner {
        id
        name
        username
        uri
        domain
      }
      name
      projectName
      projectVizportalUrlId
      vizportalUrlId
    }
    ... on Dashboard {
      sheets {
        worksheetFields {
          id
        }
        datasourceFields {
          id
        }
      }
      upstreamSheetFieldInstances(orderBy: {field: NAME, direction: ASC}) {
        ...SheetFieldInstanceFragment
      }
    }
    ... on Sheet {
      worksheetFields {
        id
      }
      datasourceFields {
        id
      }
      sheetFieldInstances(orderBy: {field: NAME, direction: ASC}) {
        ...SheetFieldInstanceFragment
      }
    }
  }
}
${SheetFieldInstanceFragmentGql}
`;
